import { EditProfileFormFooterProps } from './types';

export const EditProfileFormFooter = ({ children }: EditProfileFormFooterProps) => <div className="flex gap-4 flex-wrap">{children}</div>;
